/**
 * Vuetify Plugin Configuration
 * Implements the L⚡t-ning theme from design.yaml
 */

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.css'

// L⚡t-ning Theme Configuration
const lytningLightTheme = {
  dark: false,
  colors: {
    primary: '#339CFF',        // Electric blue
    secondary: '#64748B',      // Slate gray
    accent: '#A529FF',         // Neon purple
    success: '#32D74B',        // Green
    error: '#FF3B30',          // Red
    warning: '#FF9500',        // Orange
    info: '#339CFF',           // Electric blue
    background: '#FFFFFF',
    surface: '#F8FAFC',
  },
}

const lytningDarkTheme = {
  dark: true,
  colors: {
    primary: '#339CFF',        // Electric blue
    secondary: '#A0A0A0',      // Light gray
    accent: '#A529FF',         // Neon purple
    success: '#32D74B',        // Green
    error: '#FF3B30',          // Red
    warning: '#FF9500',        // Orange
    info: '#339CFF',           // Electric blue
    background: '#0D0B33',     // Dark gradient start
    surface: '#1A1840',        // Card background
  },
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'lytningDark',
    themes: {
      lytningLight: lytningLightTheme,
      lytningDark: lytningDarkTheme,
    },
  },
  defaults: {
    VBtn: {
      style: 'text-transform: none;',
    },
    VCard: {
      elevation: 2,
    },
  },
})
